import { useSyncExternalStore } from 'react';

/** Live result of a CSS media query. */
export function useMedia(q: string) {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(q);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => window.matchMedia(q).matches,
  );
}

/** Same breakpoint as Tailwind's `lg`: desktop layout from here up, the mobile app layout below it. */
export const DESKTOP_QUERY = '(min-width: 1024px)';

export const useIsDesktop = () => useMedia(DESKTOP_QUERY);
